import { THUNK_STATUS } from "@duosoftbg/nacid-components";
import { initialAdditionalDocApplicantDetails } from "./common/applicantDetailsInitialValues";
import { initialDocumentDetails } from "./common/documentInitialValues";
import React from "react";
import { AdditionalDocApplication } from "../types/additionalDocTypes";
import { initialAdditionalDocDetail } from "./rudiAdditionalDocInitialValues";
import SeAdditionalDocStepApplicant from "../views/components/services/additionalDoc/form/applicant/SeAdditionalDocStepApplicant";
import SeAdditionalDocStepDetails from "../views/components/services/additionalDoc/form/detail/SeAdditionalDocStepDetails";
import SeAdditionalDocStepDocuments from "../views/components/services/additionalDoc/form/documents/SeAdditionalDocStepDocuments";
import SeAdditionalDocStepFiling from "../views/components/services/additionalDoc/form/filing/SeAdditionalDocStepFiling";

export const initialSeAdditionalDocApplication: AdditionalDocApplication = {
  additionalDocDetail: initialAdditionalDocDetail,
  dataStateStatus: THUNK_STATUS.INITIAL,
  applicantDetails: initialAdditionalDocApplicantDetails,
  documentDetails: initialDocumentDetails,
  steps: [
    {
      labelCode: "l.step.applicant",
      completed: false,
      component: <SeAdditionalDocStepApplicant />,
      isEdited: false,
    },
    {
      labelCode: "l.step.additionalDoc.details",
      completed: false,
      component: <SeAdditionalDocStepDetails />,
      isEdited: false,
    },
    {
      labelCode: "l.step.attachments",
      completed: false,
      component: <SeAdditionalDocStepDocuments />,
      isEdited: false,
    },
    {
      labelCode: "l.step.filing",
      completed: false,
      component: <SeAdditionalDocStepFiling />,
      isEdited: false,
    },
  ],
};
